import * as React from "react";

function SvgMedium(props) {
  return <svg viewBox="0 0 7 6" fill="none" width="1em" height="1em" {...props}><g clipPath="url(#medium_svg__clip0_13003_1562)"><rect y={-0.001} width={6.003} height={6.002} rx={3.001} fill="#FAAD14" /></g><defs><clipPath id="medium_svg__clip0_13003_1562" /></defs></svg>;
}

export default SvgMedium;